import { render, staticRenderFns } from "./dialogAddProject.vue?vue&type=template&id=0e4527b6"
import script from "./dialogAddProject.vue?vue&type=script&lang=js"
export * from "./dialogAddProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports